import BandedResponse from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/questionsTable/BandedResponse/BandedResponse";

export default BandedResponse;
